import React from 'react';
import './CapitalDepletionAlert.css';

interface DepletionAlert {
  depletes: boolean;
  depletion_month: number;
  depletion_age: number;
  depletion_reason?: string;
}

interface CapitalDepletionAlertProps {
  alert: DepletionAlert | null | undefined;
}

const CapitalDepletionAlert: React.FC<CapitalDepletionAlertProps> = ({ alert }) => {
  if (!alert || !alert.depletes) {
    return (
      <div className="depletion-alert success">
        Nenhum risco imediato de esgotamento de capital identificado.
      </div>
    );
  }

  return (
    <div className="depletion-alert danger">
      Atenção: capital projetado para acabar no mês {alert.depletion_month + 1} (idade aproximada {alert.depletion_age.toFixed(1)} anos).
    </div>
  );
};

export default CapitalDepletionAlert;
